
$(document).ready(function () {
$('.review-image').slick({
  centerMode: false,
  arrows: false,
  slidesToShow: 6,
  slidesToScroll: 2,
  dots: false,
  responsive: [
    {
      breakpoint: 630,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToScroll: 2,
        dots: false,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 990,
      settings: {
        arrows: false,
        centerMode: false,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 2,
      }
    }
  ]
});
 $(".prev-btn-review").click(function () {
		$(".review-image").slick("slickPrev");
	});

	$(".next-btn-review").click(function () {
		$(".review-image").slick("slickNext");
	});
	$(".prev-btn-review").addClass("slick-disabled");
	$(".review-image").on("afterChange", function () {
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prev-btn-review").addClass("slick-disabled");
		} else {
			$(".prev-btn-review").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".next-btn-review").addClass("slick-disabled");
		} else {
			$(".next-btn-review").removeClass("slick-disabled");
		}
	});
});
